export default __webpack_public_path__ + "static/media/image-4.a3507ded.jpeg";